import { render } from "./PopupThongTinNhanVien.vue?vue&type=template&id=24bc18a9"
import script from "./PopupThongTinNhanVien.vue?vue&type=script&lang=js"
export * from "./PopupThongTinNhanVien.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__